/** Fired after visitor create / update / exit / delete so stats + lists refresh. */
export const VISITOR_DATA_CHANGED_EVENT = "visitor:data-changed";

export function notifyVisitorDataChanged() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(VISITOR_DATA_CHANGED_EVENT));
  }
}
